<ngb-toast
  *ngFor="let toast of toastService.toasts"
  [header]="toast.header"  [delay]="toast.delay || 5000"
  (hiddden)="toastService.remove(toast)"
>{{toast.body}}</ngb-toast>